import React, {useState} from "react";
import {APIUserConversations} from "../../../API/api";
import "../PopupOwner/popup.css";
import paperclip from "../PopupOwner/assets/paperclip.svg";
import CancelIcon from "@material-ui/icons/Cancel";
import {useTranslation} from "react-i18next";

const Popup = (props) => {
    const {
        id, active, setActive, user, changeContinuePopup
    } = props;
    const [body, setBody] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [error, setError] = useState({
        show: false,
        text: '',
    });
    const {t} = useTranslation();

    const handleSendMessage = (e) => {
        e.preventDefault();
        let formData = new FormData();
        formData.append('body', body);
        if (selectedFile) formData.append('file', selectedFile);
        APIUserConversations.sendConversationMess(id, formData)
            .then((r) => {
                if (r.status === 200) {
                    changeContinuePopup(t('chat.message-sent'))
                    setTimeout(() => {
                        changeContinuePopup(t('chat.message-sent'))
                    }, 3000)
                    setActive(false);
                    setBody("");
                    // console.log(r);
                }
            })
            .catch((e) => {
                console.log(e)
                if (e.response) {
                    let msg = "Something went wrong"
                    if (e.response.data.message === "Unverified sender") {
                        msg = "chat.only-verified-can-send-messages"
                    }
                    setError({
                        show: true,
                        text: t(msg),

                    });
                    setTimeout(() => {
                        setError(prevState => ({
                            ...prevState,
                            show: false,
                        }))
                    }, 3000)
                    console.log(e.response.data);
                }
            });
    };


    return (
        <div
            style={{
                background: active ? "rgba(0, 0, 0, 0.3)" : "transparent",
            }}
            className={active ? "modal active" : "modal"}
            onClick={() => setActive(false)}
        >
            <form className={"modal-content"} onClick={(e) => {
                e.stopPropagation()
            }}>
                <div className={"close-and-owner"}>
                    <div className={"owner-name"}>
                        {user.avatar
                            ? <img src={user.avatar} alt={"user avatar"} className={"photo-owner"}/>
                            : <span>{user.name?.split("")[0]}</span>}
                        <span>{user.name}</span>
                    </div>

                    <div className={"close-button"}>
                        <svg
                            width="24"
                            className={"close_icon"}
                            onClick={() => setActive(false)}
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M13.6416 12.0002L18.5804 7.07632C19.0069 6.61883 18.9948 5.90538 18.5522 5.46381C18.1097 5.0213 17.3972 5.00819 16.9397 5.43475L12.0001 10.3586L7.07621 5.42731C6.62059 4.96982 5.88089 4.96792 5.4234 5.42356C4.96591 5.87824 4.96402 6.61888 5.41965 7.07636L10.3584 12.0002L5.41965 16.924C4.9931 17.3815 5.00527 18.095 5.44778 18.5366C5.89029 18.9791 6.60278 18.9922 7.06029 18.5656L11.9841 13.6418L16.908 18.5656H16.9089C17.3617 19.0269 18.1033 19.0344 18.5655 18.5806C19.0267 18.1278 19.0342 17.3862 18.5805 16.9241L13.6416 12.0002Z"
                                fill="#003E47"
                                fillOpacity="0.4"
                            />
                        </svg>
                    </div>
                </div>
                <div className={`popup-error ${error.show ? 'popup-error-active' : ''}`}>
                    <CancelIcon style={{color: "red", paddingRight: "3px"}}/>
                    <span>{error.text}</span>
                </div>
                <div className={"write-message"}>
          <textarea
              name="body"
              cols="40"
              rows="8"
              placeholder={t('chat.write-a-message')}
              value={body}
              onChange={(e) => setBody(e.target.value)}
          />
                </div>

                <div className={"file-and-send"}>
                    <div className={"file"}>
                        <label className={"attach-file"}>
                            <img src={paperclip} alt={"attach-file"}/>
                            <span>{selectedFile ? t('chat.attached-file') + ` ${selectedFile.name}` : t('chat.attach-file')}</span>
                            <input
                                type="file"
                                hidden
                                accept="image/png, image/jpg, image/jpeg, image/webp"
                                onChange={(e) => setSelectedFile(e.target.files[0])}
                            />
                        </label>
                        <span className={"format"}>
                          {t('chat.attach-file-info')}:
                        </span>
                        <span className={"format"}>jpg, jpeg, png.</span>
                    </div>
                    <button
                        type={"submit"}
                        onClick={handleSendMessage}
                        disabled={!body.length}
                        className={"send"}
                    >
                        {t('chat.send')}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Popup;
